import { createContext, useContext, useMemo } from 'react';
import { useSubscribeOnMount } from "../hooks/useSubscribeOnMount";
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const BillingObservableContext = /*#__PURE__*/createContext({
  subscribe: noop,
  unsubscribe: noop,
  notifyToRefresh: async () => {}
});
export function useBillingObservable() {
  return useContext(BillingObservableContext);
}
export function useSubscribeToBillingObservable(callback) {
  const actions = useBillingObservable();
  useSubscribeOnMount(actions, callback);
}
export const BillingObservableProvider = _ref => {
  let {
    children,
    observable
  } = _ref;
  const value = useMemo(() => {
    return {
      subscribe(subscribeData) {
        observable.subscribe(subscribeData);
      },
      unsubscribe(id) {
        observable.unsubscribe(id);
      },
      notifyToRefresh() {
        return observable.notify();
      }
    };
  }, [observable]);
  return /*#__PURE__*/_jsx(BillingObservableContext.Provider, {
    value: value,
    children: children
  });
};